import React from "react";
import mrrobot from "../asset/jadi-hacker-kaya-difilm/mrrobothack.webp";
import jakartapagi from "../asset/jadi-hacker-kaya-difilm/jakartapagi.jpg";
import robotaction from "../asset/jadi-hacker-kaya-difilm/robotaction.webp";
import arsenal from "../asset/jadi-hacker-kaya-difilm/arsenal.jpg";
import hackerpolice from "../asset/jadi-hacker-kaya-difilm/hackerpolice.jpg";
import c4 from "../asset/jadi-hacker-kaya-difilm/c4.jpg";

class HackerFilm extends React.Component {
  render() {
    return (
      <>
        <div className="container pt-4 pb-4 content-detail">
          <div className="header pb-4">
            <h1 className="font-PoppinsBold">
              Jadi <span className="font-green">Hacker</span> Kaya Di film-film
              👽.
            </h1>
            <span className="font-PoppinsBold mx-1 text-grey">20-11-2025</span>
          </div>
          <div className="nav-content shadow-sm p-3 mb-5">
            <h2 className="font-PoppinsBold">Opening</h2>
            <p className="text text-justify pb-2">
              Hallo semuanya, kembali lagi ke blog saya, blog random yang
              sebenarnnya isi nya full yapping, tapi dikemudian hari saya
              berharap juga publish hasil belajar / research saya nantinya,
              setelah melewati struggling yang sangat panjang, akhirnya saya
              dengan senang hati mengumumkan bahwa saya telah lulus <b>OSCP+</b>{" "}
              <a
                href="https://credentials.offsec.com/0f393dfc-d631-4711-bc16-8d87ba8d119f#acc.LaeNcvif"
                className="font-green text-decoration-none mx-1"
              >
                view this cert
              </a>{" "}
              <p>
                {" "}
                Alhamdulillah, setelah melewati perjalanan panjang akhirnya saya
                bisa memiliki waktu senggang untuk update blog random ini.
              </p>
            </p>
            <h2 className="font-PoppinsBold">Red Teaming</h2>
            <img src={mrrobot} className="img-fluid pb-1" alt="Responsive" />
            <p className="text text-justify pb-2">
              Red team merupakan bentuk uji penetration (pentest) yang dilakukan
              dengan mensimulasikan serangan cyber secara nyata kepada
              perusahaan. Metode red team sangat berbeda dengan uji pentest
              biasa, red team bertujuan untuk memanfaatkan kelemahan rancangan
              infrastruktur TI perusahaan sebanyak-banyaknya. Pada intinya red
              team merupakan suatu cara hacker menuju suatu objective yang mana
              hacker tidak diberi akses atau informasi apapun.
            </p>
            <p className="text text-justify pb-2">
              Ketika saya menduduki bangku sekolah, saya seneng sekali nonton
              Mr.Robot (film hacker series) yang mana seorang pemuda bernama
              elliot, melakukan explorasi pada dunia digital, dengan tujuan
              tertentu, scene-scene eliot, mebuat serangan phising, malware, dan
              remote control menuju perangkat target sungguh menakjubkan, namun
              tidak terbayang saya yang menonton scene tersebut di 6 tahun
              kemudian melakukan hal yang elliot lakukan, <b>Disclaimer</b> yang
              lakukan tentu legal, pada intinya saya bekerja disalah cyber
              security consultant, yang mana pada project kali ini saya di beri
              kesempatan untuk melakukan red teaming, (menjadi orang luar yang
              memasuki suatu gedung, kemudian melakukan explorasi sehingga bisa
              memiliki kontrol kearah internal) bahkan mengambil ahli control
              jaringan, serta perangkat di gedung tersebut. Lalu apa yang saya
              lakukan ? mungkin kita ubah ke mode novel kwkw, letsgooo (100%
              kisah ini nyata yang saya alami.)
            </p>
            <h2 className="font-PoppinsBold">This Day Coming</h2>
            <img
              src={jakartapagi}
              className="img-fluid pb-1"
              alt="Responsive"
            />
            <p className="text text-justify pb-2">
              Seperti biasa langit kota ini cerah pagi hari, sebenarnya bukan
              hal yang biasa bagi saya menaruh pivot alat yang mana pada
              akhirnya alat alat kami bisa dikontrol dari jauh, namun pengalaman
              pertama bagi saya untuk melakukan hal ini secara diam diam untuk
              menuju objective yang kami tuju, tentu plan sudah kami lakukan
              untuk menunjang keberhasilan hal ini, tapi tentu hal di lapangan
              suatu yang mustahil bisa kami tebak, lagi pula ini pertama kali
              saya melakukan apa yang hacker hacker difilm itu lakukan.
            </p>
            <p className="text text-justify pb-2">
              Plan, pertama saya, tentu berangkat kekantor, packing alat alat
              yang kami butuhkan untuk melancarkan aksi kami, tentu saya dan
              rekan saya selalu berdua melakukan hal ini, kami sudah terbiasa
              dan sudah saling memahami satu sama lain, tapi kali ini berbeda
              kwkwk, new scenario, new experience kami lakukan disini, jam
              menunjukkan 14.00, kami prepare menuju statiun MRT untuk menuju
              lokasi target kami.
            </p>
            <p className="text text-justify pb-2">
              Pukul 15.00 kami tiba dilokasi, waktu yang pas sesuai plan kami,
              waktu ini sesuai, dijam ini para pegawai akan menunggu sholat
              ashar, mereka akan lebih santai dengan kegiatan persiapan pulang
              mereka, kami sudah mulai memasuki area gedung, alat kami melewati
              xray, hal yang mudah kami lakukan untuk mengelabui security dan
              service desk yang bertanya, data diri kami ditaruh di service desk
              untuk menukar id card tamu, segala pertanyaan dari security, dan
              service desk berhasil kami lewati, menujulah kami kelantai yang
              kami tetapkan.
            </p>
            <p className="text text-justify pb-2">
              Sepanjang jalan menuju lift kami melakukan screening, melihat
              lokasi lokasi yang meiliki potensi menjadi satu hal yang dapat
              kami explore, tibalah dilantai yang kami tuju, kami diasingkan
              disuatu ruangkan, disuruh mempersiapkan apa yang harus kami
              siapkan. jam menunjukan pukul 16.00 waktu yang tepat seharusnya
              hal ini dilakukan, sambil menuju ruangan kurang lebih 10x10 meter
              dilantai tersebut, kami memperhatikan apa saja yang ada dilantai
              tersebut, dimulai dari alat target kami untuk pivot ke internal,
              akses akses lain, seperti kabel ethernet, perangkat lain yang
              dapat kami explore menjadi jalan kami menuju internal. (hmm
              sepertinya mustahil) setelah kami cek tidak ada yang oke selain
              target utama kami sesuai plan.
            </p>
            <h2 className="font-PoppinsBold">Lets start the action</h2>
            <img
              src={robotaction}
              className="img-fluid pb-1"
              alt="Responsive"
            />
            <p className="text text-justify pb-2">
              Memasuki area lantai 10x10 meter tersebut, dengan aktivitas yang
              padat, "ahh kami salah perkiraan", hari itu aktivitas sangat
              padat, semua orang melihat ke arah kami, padahal kami sudah
              menggunakan salah satu penanda service alat "x", alat target mulai
              kami sentuh, kami memperhatikan kelistrikan, dan kabel kabel yang
              ada, kami mulai atur sesuai rencana, baru 3 menit di tempat,
              datang para karyawan yang memiliki keperluan dengan alat ini,
              "Senyum kami lemparkan", pertanyaan pertama mulai muncul.
            </p>
            <pre className="px-3">
              k=karyawan, s=saya p=patner <br />
              k: "rusak alat nya ya mas?" <br />
              == hari ini saya dan rekang saya jadi pembohong handal kwkwwk ==
              <br />
              s: "iya nih bu, katanya gangguan jadi kami check (Dalam hati,
              shitt ini alat aja baru saya pegang)" <br />
              k: "ohh belom tau ya mas, kenapa ? tapi saya pake aman aja nih"{" "}
              <br />
              s: "iya bu, tadi problem sekarang aman, kayanya karena sudah mulai
              kami cek nih". <br />
              == sesuai plan intinya patner saya mengurus apa yang harus
              diconfig dari alat ini agar bisa terhubung ke pivot alat kami,
              saya mengecek kemungkinan dan menjawab para pertanyaan gaib yang
              ada" <br />
              == suasana sangat diluar kendali kami, jam ini ternyata tidak baik
              bagi kami, pandangan orang-orang menuju kami, namun karena kami
              menggunakan salah satu penanda servis alat jadi cukup aman bagi
              kami == <br />
              == 5 menit berlalu, temen patner saya menoleh saya == <br />{" "}
              <br />
              p: "mas ini aneh mas, ini ada suatu yang beda (hahaha sambil
              berkeringet dengan adrenalin kwkwkw)" <br />
              == pada intinya kami memerlukan suatu informasi tentang alat ini,
              tentu ini tidak mungkin kami bertanya ke orang orang sekitar,
              kwwkwk (kami sedang role play jadi pegawai servis), asumsi mereka
              akan sangat bodoh ini kwkwkw tukang servis== <br />
              == bermodal explorasi saya, saya menemukan informasi tentang
              perangkat ini diinternet, yap dan saya valid melakukan attack
              physical yang membawa kami kesuatu informasi penting== <br />
              == setelah 10 menit, alat berhasil kami handel, kami sudah
              menguasai alat ini dari jauh == <br />
              == nice plan, dan nice eksekusi dengan ketegangan == <br />
              == kami tinggalkan area lantai tersebut menuju ruangan, kecil
              kami, untuk memastikan kami sudah bisa mengontrol alat tersebut =={" "}
              <br />
              == tidak pernah terbayangkan bagi saya dan patner saya hal ini
              bisa kami lakukan, dengan yakin dan panik kwkwk == <br />
            </pre>
            <p className="text text-justify pb-2">
              pulanglah kami menuju, rumah dengan tenang dan damai, hari-hari
              berjalan, kami menemukan yang aneh, alat tersebut memang berhasil
              kami control, dan kami takeover, tapi yang menarik alat kami tidak
              menghantarkan kami menuju objective kami, "shitt ini aneh",
              scenario yang kami buat ternyata tidak 100% berhasil, beragam cara
              kami lakukan dari jarak jauh hasil nya sia-sia, berdikusilah team,
              untuk menentukan ide apa lagi yang dapat kami lakukan, untuk saat
              ini kami hanya bisa memanfaatkan alat ini untuk mencari informasi
              lebih dalam menuju objective, beragam ide, skenario network yang
              kami lakukan, kami coba di lab kami, akhirnya kami menemukan inti
              permasalahannya. pada intinya manageble jaringan, perangkat, dan
              infra di target kami sudah sangat baik, semua tertata rapih,
              terjaga oleh baragam tools security yang canggih, implemen nya
              juga bukan main main, kami menemukan banyak list vendor yang sudah
              mereka gunakan jasa nya untuk mengelola jaringan dan infra di
              kantor ini sangai clean dan termanage.{" "}
            </p>
            <p className="text text-justify pb-2">
              Tapi mindset lain tertanam diantara saya dan patner saya, kalau
              kami menyerah sama saja kami menyerah ketika perang ditangkap
              pasukan lawan, "The idea coming" kami menemukan ide, ide yang
              sangat aneh tapi ini sangat mungkin dapat dilakukan untuk melewati
              hal hal yang sudah mereka implemen.
            </p>
            <img src={arsenal} className="img-fluid pb-1" alt="Responsive" />
            <br />
            <h2 className="font-PoppinsBold pt-3">We Ready for WAR Again!</h2>
            <p className="text text-justify pb-2">
              Setelah melewati hari yang sangat panjang, setup, ujicoba, kami
              siap perang kembali, kami siap ke lokasi untuk melakukan hal yang
              sudah pernah kami lakukan, ini bukan lagi pertama kali, kami
              lakukan ini sudah menjadi kedua yang kami lakukan, kami hadir
              dengan pengalaman, keberanian, dan degedegkan kwkwkwkw, Seteleh
              menyusun beragam plan, belajar dari pengalaman pertama, kami rasa
              waktu malam lebih tepat untuk kami lakukan, akhirnya kami
              melakukan set waktu jam 20.00 malam untuk melakukan aksi ini. Jam
              menunjukkan pukul 18.00 alat sudah kami siapkan, seperti biasa
              dari kantor kami menaiki MRT menuju lokasi, sampai dilokasi, mesin
              xray melakukan scan tas kami, security, service desk, kami lewati,
              beragam pertanyaan mudah kami jawab untuk melewati, sekalipun itu
              jam malam, seakan-akan kami sudah memiliki jam terbang melakukan
              hal ini di pengalaman ke-dua.
            </p>
            <p className="text text-justify pb-2">
              Menukarkan identitas kami untuk kebutuhan masuk, melewati lorong
              menuju lift, screening kami lakukan tempat tempat menarik yang
              mungkin tidak pernah kami duga yang bisa kami jadikan exporasi
              kami, lantai yang kami tuju telah sampai, ruangan tempat kami
              menyusun rencana kami duduki, lantai dengan luas 10x10 meter
              kembali ada dihadapan kami. kali ini suasana nya berbeda cukup
              senggang, namun ini diluar kendali kami lagi, siapa sangka ada
              karyawan yang bekerja dimalam hari, ini yang kami namakan 1000
              pivot kami pasang, tapi di lokasi, semua bisa terjadi. namun
              optimis masih ada dipikiran kami, kami yakin semua bisa kami
              lakukan dan pasti kali ini potensi berhasil lebih besar.
            </p>
            <h2 className="font-PoppinsBold pt-3">The tiger killed the deer</h2>
            <img
              src={hackerpolice}
              className="img-fluid pb-1"
              alt="Responsive"
            />
            <p className="text text-justify pb-2">
              Pintu ruangan setup kami buka, lantai 10x10 kami perhatikan dengan
              seksama, 5 karyawan tersisa dilantai tersebut, dengan menggunakan
              pengenal servis alat "x", dengan percaya diri kami lewati lantai
              tersebut, senyum kami lempari setiap orang yang memperhatikan
              kami, alat target kembali kami sentuh, semua utuh, alat pivot kami
              tidak terdeteksi posisi masih rapih, tidak diketahui orang bahkan
              saya yakin orang-orang yang menggunakan alat ini sekalipun tidak
              menyadari ada yang kami ubah dari alat ini. "Tapi sebenarnya
              dibalik kepercayaan kami, ada yang kami khawatirkan dari ruangan
              kecil kami setup, kami tidak menyangka masih ada beberapa karyawan
              yang lembur, dan bersinggungan dengan alat ini, tapi dengan
              percaya diri kami masih yakin dengan yang kami lakukan". Alat kami
              sentuh 2 menit kami sentuh alat tersebut, "muncul seorang pria
              (berusia 31 tahun mungkin) menuju alat kami, kode saya berikan
              kepatner saya untuk menutup laptop terlebih dahulu, melakukan hal
              santai seakan akan, mencari tau permasalahan yang ada pada alat x".
              <br /> <br />
              Siapa sangka percaya diri kami kwkw runtuh, seketika ketika
              seseorang mendekat, siapa sangka ternyata dibelakang alat x ini,
              tanpa diduga ada kulkas yang mentrigger orang tersebut untuk
              membuat suatu minuman, "lagi lagi ini diluar expetasi kami,
              pengalaman melihat lingkungan sekitar menjadi catatan kami
              kedepannya", tentu senyum kami lemparkan untuk memastikan bahwa
              kami seseorang yang tidak dicurigai, dan yap benar pertanyaan
              muncul
            </p>
            <pre className="px-3">
              k=karyawan, s=saya p=patner <br />
              k: "kenapa ini mas alatnya ?" <br />
              s: "biasa mas, problem gak diduga nih mas" <br />
              k: "ohh, aneh juga ya mas malem malem gini" <br />
              == kwkw lagi lagi sudah tidak enak perasaan kami, saya bertatapan
              dengan patner saya tapi, kami berusaha oke disituasi ini== <br />
              s: "iya nih mas, soalnya besok ada urusan ditempat lain" <br />
              k: "oh oke mas, lanjut, (karyawan berjalan meninggali kami)"{" "}
              <br />
              == jam menunjukann pukul 20.06 , beberapa menit kami terbuang
              untuk menjawab pertanyaan == <br />
              == namun tidak terduga, setelah kami kira aman, karyawan tersebut
              kembali == <br />
              k: "mas tadi saya lihat kok tapi ada kabel ke bawah ya, saya rasa
              alat x disini gak begini dh mas?" <br />
              s: "dari dokumentasi pemasangan kami, semua seperti ini ya pak,
              sesuai spesifikasi alat" <br />
              == saya mengkode patner saya untuk menutup laptop, tapi apa boleh
              buat saya rasa dia terbawah suasana untuk segera menyelesaikan
              konfigurasi yang ada == <br />
              == beragam pertanyaan dilontarkan saya berhasil menjawab dan
              meyakinkan == <br />
              == sampai akhir nya disuatu momen, patner saya yang asik untuk
              menyelesaikan membuka salah satu software networking== <br />
              k: "loh kok mas kok buka app x, ini bukannya buat abc ?" <br />
              k: "wah ini pasti akan ke a ke b ke c ? ini gak boleh nih mas"?{" "}
              <br />
              s: "maksudnya gimana ya mas ? kami kurang ngerti sih karena kami
              ditraining hanya untuk mengafal" <br />
              k: "oh ini pasti gini kan mas, ini gak bisa mas" <br />
              == saya yakin orang ini orang IT, dia paham konsep dan bahasa yang
              digunakan sudah sangat jelas teknis" <br />
              s: "perihal itu saya gak tau mas, saya cuman by dokumentasi aja
              sih mas" <br />
              == tangan patner saya jelas sekali getar, (patner saya ini junior
              saya dikantor, tapi saya berani jamin kemampuan konfig nya paling
              oke dikantor untuk saat ini, dan teman diskusi saya) <br />
              k: "gak mas, ini pasti mas pake a b c, tolong sebutin a b c ini
              apa aja mas " ? <br /> s: "oh saya gk tau mas, itu apa ya, saya hanya by
              dokumentasi aja" lagi lagi saya ulang jawaban ini, saya yakinkan
              dia kalau kami hanyalah orang yang membaca guide, tanpa mengerti
              alurnya <br />
              == beragam pertanyaan beliau lemparkan, dari teknologi, nama alat,
              spesifikasi alat beliau uji, dan saya serta patner saya berhasil
              jawab== <br />
              == sampai disatu titik, beliau membawa teman kwkwkw s(2 wanita, 1
              pria untuk memastikan apakah saya seorang servis alat x) dan orang ini berterus terang bahwa dia orang network yang handel jaringan internal dan eks == <br />
              == tentu ini sudah tidak mungkin ini diluar kendali kami, percaya
              diri kami hancur kwkwkw, keringat dari rekan saya, wkkw bahkan
              saya sendiri mulai keluar == <br />
              == pengalaman mahal yang kami dapatkan bahkan diberagam kursus,
              modul mahal tidak akan pernah kami dapatkan== <br />
              == habis sudah, kami dibawah ke suatu ruangan, diintrograsi (namun
              tidak sampai kesecurity karena kami sudah tau ini sudah stuck kami
              jawab), malam itu menjadi malam yang sangat mahal bagi saya dan
              patner saya untuk belajar kedepannya == <br />
              == MRT menuju kantor menjadi pertanyaan berulang == <br />
              p: "Mas kok kita bisa ketangkep ya kwkwk ?" (terus diulang patner
              saya) <br />
              s: "Yaudalah lah r** kwkwkkw, gak usah ngerenung trus (malam itu
              hujan besar kwkwkkw, lebur sudah bersama kepercayaan diri)" <br />
              == Pop mie, menjadi penutup obrolan malam itu (jam 23.00 kami
              masih dikantor dan merenung)==
            </pre>
            <h2 className="font-PoppinsBold pt-3">We drop magic part</h2>
            <img src={c4} className="img-fluid pb-1" alt="Responsive" />
            <p className="text text-justify pb-2">
              Malam itu memang alat kami gagal terpasang, namun ada satu part
              yang tidak kami ceritakan, sore sebelum berangkat patner saya
              memberitahu saya, bawa dia menyiapkan alat kecil yang sudah kami
              config, untuk backup plan, namun kami juga tidak yakin dengan alat
              ini, sebelum kami melakukan screening disepanjang jalan dan tentu screening
              dilantai dengan luas 10x10 meter itu kami, melihat lokasi
              pontesial untuk kami taruh alat kecil itu secara cuma cuma.
              <br />
              Ruangan kantor kami sunyi, sisa kami berdua, menikmati popmi,
              laptop kami buka, siapa sangka, alat kecil ini bisa kami remote
              dari jauh. besok pagi nya kami remote alat kecil ini, kami cari
              informasi sedetail mungkin apa yang bisa dijangkau alat kecil ini,
              skenario yang kami revisi, kami implemen dari jauh melalui alat
              kecil ini. "Amazing Hack", siapa sangka alat kecil yang kami
              gunakan untuk backup plan, berhasil kami config secara jauh, dan
              berhasil menjangkau area objective internal yang kami tuju kwkwkw,
              "Abosulutely cinema". 
              <br />
              <br />finally we go internal. saat ini kami sudah
              bisa menuju objective, kami remote alat alat kami, kami sudah
              seperti hacker di film-film berhasil masuk ke gedung kantor orang,
              menaruh alat, menghindari tantangan, yang kami sendiri tidak
              yakin, pengalaman mahal yang kami lakukan untuk berkembang, hal
              legal yang kami lakukan untuk kebaikan, (Disclaimer, semua hasil
              kegiatan akan dilaporkan dan sudah di tahap fixing. tentu semua
              legal dan saya tidak menyebutkan setiap hal yang sifat nya
              confidential).
            </p>
            <h2 className="font-PoppinsBold pt-3">Kesan-Pesan</h2>
            <p className="text text-justify pb-2">
              Bagi siapa pun yang berkeja dibidang IT pasti paham, trouble pasti
              akan muncul tanpa diduga, sejauh apa kita melakukan troubleshoot,
              dan usaha untuk fix, tentu mindset ini harus terus dijaga, agar
              kita bisa menuju objective yang kita inginkan. Terimakasih untuk
              para patner, senior, dan rekan rekan yang membantu saya dalam
              berkembang dan memberikan ide ide serta pengalaman yang menarik.
            </p>
          </div>
        </div>
      </>
    );
  }
}

export default HackerFilm;
